import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { selectMixedContentFilterClauses, selectSearchText } from '../../selectors/ContentFilterSelectors';
import { selectContentTotalLength } from '../../selectors/ContentSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { SearchSpace, SearchSpaceDispatchProps, SearchSpaceOwnProps, SearchSpaceStateProps } from './SearchSpace';
import { UnifiedSearchSpace, UnifiedSearchSpaceDispatchProps, UnifiedSearchSpaceOwnProps, UnifiedSearchSpaceStateProps } from './UnifiedSearchSpace';

const mapStateToProps: MapStateToProps<UnifiedSearchSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  searchTerm: selectSearchText(state),
  contentFilters: selectMixedContentFilterClauses(state),
  fetchedContentCount: selectContentTotalLength(state),
  isFetchingContent: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<UnifiedSearchSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedUnifiedSearchSpace: React.ComponentClass<UnifiedSearchSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(UnifiedSearchSpace);
